import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChangePriorityAction, MarkTourResolvedAction } from '@ngxs-store/control-tower-store/control-tower.actions';
import { DeleteCustomerContactPersonAction } from '@ngxs-store/customer-store/customer.actions';
import { AllocateUserByTourIdAction, MarkChatAsResolvedAction, UpdateDocumentsCheckedAction, UpdateTadClosedAction, UpdateUncCheckedAction } from '@ngxs-store/customs-store/customs.actions';
import { CancelTourAction, MakeTourCriticalAction, MakeTourHeldAtCustomsAction, MarkTourCompletedAction, UnCancelTourAction } from '@ngxs-store/managed-tour-store/managed-tour.actions';
import { WorkUnSplitAction } from '@ngxs-store/work-split-store/work-split.actions';
import { Store } from '@ngxs/store';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {
    modalTitle = 'Confirmation Dialog';
    submitTitle = 'Yes';
    cancelBtn = 'Cancel';
    subConfirmationText = '';
    changeComponent: boolean = false;
    priority: string = "low";
    @Input() id: number;
    @Input() tourId: number;
    @Input() buttonType: string;

    constructor(
      public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
      public builder: FormBuilder, private store: Store,
      @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.id = data.id;
        this.tourId = data.tourId;
        this.changeComponent = data.changeComp;
    }

    ngOnInit(): void {
      this.modalTitle = this.data.modalTitle || this.modalTitle;
      this.submitTitle = this.data.submitTitle || this.submitTitle;
      this.subConfirmationText = this.data.subConfirmationText || this.subConfirmationText;
      this.buttonType = this.data.buttonType;
      if(this.data.buttonType == 'Escalate'){
        this.cancelBtn = 'No';
      }
    }

    back(): void {
      this.dialogRef.close(false);
    }

    save(){
        if(this.buttonType === 'Cancel'){
            this.store.dispatch(new CancelTourAction(this.id));
            this.dialogRef.close(false);
        }else if(this.buttonType === 'UnCancel'){
            this.store.dispatch(new UnCancelTourAction(this.id));
            this.dialogRef.close(false);
        }else if(this.buttonType === 'Critical'){
            this.store.dispatch(new MakeTourCriticalAction(this.id,true));
            this.dialogRef.close(true);
        }else if(this.buttonType === 'NonCritical'){
            this.store.dispatch(new MakeTourCriticalAction(this.id,false));
            this.dialogRef.close(false);
        }else if(this.buttonType === 'HeldAtCustoms'){
            this.store.dispatch(new MakeTourHeldAtCustomsAction(this.id,true));
            this.dialogRef.close(true);
        }else if(this.buttonType === 'Complete Tour'){
            this.store.dispatch(new MarkTourCompletedAction(this.id));
            this.dialogRef.close(false);
        }else if(this.buttonType === 'NotHeldAtCustoms'){
              this.store.dispatch(new MakeTourHeldAtCustomsAction(this.id,false));
              this.dialogRef.close(false);
        }else if (this.buttonType === 'Unsplit'){
            this.store.dispatch(new WorkUnSplitAction());
            this.dialogRef.close(false);
        }else if (this.buttonType === 'Unregister2FA'){
            this.dialogRef.close(true);
        }else if (this.buttonType === 'YesValidation'){
            this.dialogRef.close(true);
        }else if(this.buttonType === 'Delete'){
            this.store.dispatch(new DeleteCustomerContactPersonAction(this.id));
            this.dialogRef.close(true);
        }else if(this.buttonType === 'Resolve'){
            this.store.dispatch(new MarkTourResolvedAction(this.id, this.tourId));
            this.dialogRef.close(true);
        }else if(this.buttonType === 'Escalate'){
            this.dialogRef.close(true);
        }else if(this.buttonType === 'ClearData'){
            this.dialogRef.close(true);
        }else if(this.buttonType === 'Assign'){
            this.dialogRef.close(true);
        }else if(this.buttonType === 'CloseIssue'){
            this.dialogRef.close(true);
        }else if(this.buttonType === 'Change'){
            this.store.dispatch(new ChangePriorityAction(this.id, this.tourId, this.priority));
            this.dialogRef.close(true);
        }else if(this.buttonType === 'Allocate'){
            this.store.dispatch(new AllocateUserByTourIdAction(this.id))
            .pipe(
                catchError(error => {
                    console.error('Failed to allocate user:', error);
                    return EMPTY;
                })
            )
            .subscribe(() => {
                this.dialogRef.close(true);
            });
        }else if(this.buttonType === 'Checked'){
            this.store.dispatch(new UpdateDocumentsCheckedAction(this.id));
            this.dialogRef.close(true);
        }else if(this.buttonType === 'Claimed'){
            this.store.dispatch(new UpdateUncCheckedAction(this.id));
            this.dialogRef.close(true);
        }else if(this.buttonType === 'Close'){
            this.store.dispatch(new MarkChatAsResolvedAction(this.id, this.tourId));
            this.dialogRef.close(true);
        }else if(this.buttonType === 'CloseTAD'){
            this.store.dispatch(new UpdateTadClosedAction(this.id));
            this.dialogRef.close(true);
        }else if(this.buttonType === 'Continue'){
            this.dialogRef.close(true);
        }
    }
  }
